// extracted by mini-css-extract-plugin
export default {"root":"SearchInput-root__KlDdj","icon":"SearchInput-icon__ChEP4","inputWrapper":"SearchInput-inputWrapper__vKIc1","input":"SearchInput-input__HZh7V"};